// Utilities for creating URL-friendly slugs and stripping diacritics
export function stripDiacritics(input: string): string {
  if (!input) return "";

  // Normalize and remove combining marks
  let s = input.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");

  // Romanian-specific letters that don't decompose predictably
  s = s
    .replace(/[șşȘŞ]/g, "s")
    .replace(/[țţȚŢ]/g, "t")
    .replace(/[ăĂ]/g, "a")
    .replace(/[âÂ]/g, "a")
    .replace(/[îÎ]/g, "i");

  return s;
}

interface SlugifyOptions {
  separator?: string;
}

export function slugify(input: string, options: SlugifyOptions = {}): string {
  const sep = options.separator ?? "-";
  if (!input) return "";

  // Strip diacritics first
  let s = stripDiacritics(input);

  // Lowercase
  s = s.toLowerCase();

  // Remove any characters that are not alphanumeric, space or separator
  s = s.replace(/[^a-z0-9\s-]/g, "");

  // Replace whitespace with the separator
  s = s.trim().replace(/\s+/g, sep);

  // Collapse multiple separators
  const esc = sep.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
  const multiSep = new RegExp(`${esc}{2,}`, "g");
  s = s.replace(multiSep, sep);

  // Trim separators
  s = s.replace(new RegExp(`^${esc}|${esc}$`, "g"), "");

  return s;
}

export default slugify;
